<template>
  <div class="get-deep-link-modal">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Links for: {{ concept.name }}</p>
      </header>
      <div class="modal-card-body">
        <b-field label="Search and select the group">
          <mc-group-select
            v-model="selectedGroup"
            @input="groupSelectHandler"
          ></mc-group-select>
        </b-field>
        <fragment v-if="selectedGroup">
          <div
            v-if="groupDeepLinks.selectedLoading || groupDeepLinks.submitting"
            class="get-deep-link-modal__message-root"
          >
            <fragment v-if="groupDeepLinks.submitting">
              <b-loading active :is-full-page="false" />
              <span
                >There is no previously generated link, genrating one for
                you!</span
              >
            </fragment>
            <fragment v-else>
              <b-loading active :is-full-page="false" />
              <span>Getting the required deepLink!</span>
            </fragment>
          </div>
          <div
            v-else-if="groupDeepLinks.selectedError"
            class="get-deep-link-modal__message-root"
          >
            <mc-error-layout
              :message="`Failed to load link: ${error.message}`"
            />
          </div>
          <div v-else class="get-deep-link-modal__message-root">
            <b-field class="get-deep-link-modal__message-root__link-field">
              <b-input
                ref="uniqueIdTextField"
                :value="groupDeepLinks.selected.url"
                placeholder="Video URL"
                type="text"
                expanded
                readonly
              />
              <p class="control">
                <b-button
                  type="is-info"
                  icon-right="content-copy"
                  @click="copy(groupDeepLinks.selected.url)"
                />
              </p>
            </b-field>
          </div>
        </fragment>
        <div v-else class="get-deep-link-modal__message-root">
          Please select a group to get the link.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

import { copyToClipboard } from '../../utils/string';
import { mapActions, mapState } from 'vuex';

export function openGetDeepLinkModal(parent, props) {
  return new Promise((resolve, reject) => {
    parent.$buefy.modal.open({
      parent,
      component: getDeepLinkModal,
      hasModalCard: true,
      events: {
        input: resolve
      },
      props,
      onCancel: reject
    });
  });
}

const getDeepLinkModal = {
  data: function() {
    return {
      selectedGroup: null
    };
  },
  props: {
    concept: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState(['groupDeepLinks'])
  },
  methods: {
    ...mapActions('groupDeepLinks', ['getDeepLink']),
    copy(url) {
      copyToClipboard(url);
      this.$buefy.toast.open({
        message: 'Copied!',
        type: 'is-success'
      });
    },
    async groupSelectHandler(event) {
      await this.getDeepLink({
        concept: this.concept,
        groupId: event.id
      });
    }
  }
};

export default getDeepLinkModal;
</script>

<style lang="scss" scoped>
.get-deep-link-modal {
  .modal-card {
    min-height: 16rem;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  &__message-root {
    margin-top: 2rem;
    position: relative;
    text-align: center;
    min-height: 6rem;
    &__link-field {
      margin: 0 3rem;
    }
  }
}
</style>
